const mapValues = (
    obj: { [key: string]: any },
    fn: (a: any) => any
): { [key: string]: any } =>
    Object.keys(obj).reduce((acc, key) => ({ ...acc, [key]: fn(obj[key]) }), {})

export default mapValues
